import { Box, Button, Paper, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DropdownMenu from './Components/searchOptionComponents/DropdownMenu';
import BookingTable from './Components/Tabel/BookingTable';
import { getMangeData } from '../../actions/mangeAction';
import Progress from '../../components/Loader/Progress ';
import AnimatedNumbers from "react-animated-numbers";
import { getCount } from '../../actions/getCountAction';
import { initialBookingForm } from '../../actions/formAction';
import { resetData } from '../../slices/manageSlice';

function Booking() {

    const [searchParams] = useSearchParams();
  const fetchData = useSelector((state) => state.manage);

    const location = useLocation();

    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchor] = useState(null);

    const countReducer = useSelector((state) => state.fetchCount);
    

    const dataGridPaperRef = useRef(null);


    const handlingFetchData = () => {
            dispatch(getMangeData({ mode:"booking", query: searchParams.toString() }))

    };

    useEffect(() => {

                dispatch(initialBookingForm())
                dispatch(getCount({ mode: "booking" }))


            return () => {
                            dispatch(resetData())
             };
                


    }, [dispatch]);


    const handleCardClick = (name, id) => {
        // Get the current query parameters
        const searchParams = new URLSearchParams(location.search);
        const pageSize = searchParams.get('PageSize') || null;

        // Set the 'name' parameter to the given id
        if (name === 'Status') {
            searchParams.set('Status', id);
            if (pageSize === null) {
                navigate(`/booking?Status=${id}&PageSize=5`)
            } else {
                navigate(`/booking?Status=${id}`)
            }

        } else {
            if (pageSize === null) {
                navigate(`/booking?SearchOption=${id}&PageSize=5`)
            } else {
                navigate(`/booking?SearchOption=${id}`)
            }

        }


        if (dataGridPaperRef.current) {
            dataGridPaperRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }

    };


    useEffect(() => {
            dispatch(getMangeData({ mode:"booking", query: searchParams.toString() }))
    
        }, [searchParams.get("PageSize"), searchParams.get("PageNumber"), searchParams.get("SortOrder"), searchParams.get("SortBy") , searchParams.get("MixSearch")])
    



    return (
        <Box sx={{ width: '100%', bgcolor: '#F7F8FA', minHeight: '100vh', p: { xs: 0, md: 2 } }}>
            <Box sx={{ display: 'flex', justifyContent: "space-between", gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
                    <EditCalendarIcon sx={{ color: '#0B3C5D', fontSize: 36 }} />
                    <Typography variant="h4" sx={{ color: '#0B3C5D', fontWeight: 800, letterSpacing: 1 }}>
                        {t('Booking')}
                    </Typography>

                </Box>


                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'end', justifyContent: 'end', mb: 3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ borderRadius: 2, fontWeight: 700, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        startIcon={
                            <AddCircleOutlineIcon sx={{ color: theme.palette.secondary.main, fontSize: 24, bgcolor: theme.palette.background.paper, borderRadius: '50%' }} />
                        }
                        onClick={() => { navigate('/addBooking'); }}
                    >
                        {t('New Booking')}
                    </Button>

                </Box>

            </Box>




            {/* إحصائيات الحجز */}
            <Paper
                sx={{
                    p: { xs: 1, md: 3 },
                    minHeight: 180,
                    flexGrow: 1,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)',
                    borderRadius: 4,
                    boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                    border: '1px solid #e9ecef',
                    mb: 3,
                }}
                anchorEl={anchor}
            >
                {countReducer.loading === 'pending' || countReducer.loading === 'idle' ? <Progress /> :
                    <Box>
                        <Box sx={{ display: 'flex', mt: 2, justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
                            {countReducer.Object?.map((item, index) => {
                                    if (item?.name?.toUpperCase() === 'Total'.toUpperCase()) {

                                            return (<></>)
                                        }
                                // ألوان الدائرة والخط حسب الفهرس
                                const circleColor = ['#0B3C5D', '#D9B310', '#1A5F8C', '#A98A0C', '#F3D351', '#051E30'][index % 6];
                                const textColor = (index % 6 === 0 || index % 6 === 2 || index % 6 === 5) ? '#fff' : '#0B3C5D';
                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: 130,
                                            height: 160,
                                            borderRadius: 4,
                                            background: '#fff',
                                            boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.08)',
                                            border: '1px solid #e9ecef',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            transition: 'transform 0.18s, box-shadow 0.18s',
                                            '&:hover': {
                                                transform: 'scale(1.06)',
                                                boxShadow: '0 8px 24px 0 rgba(11, 60, 93, 0.16)',
                                            },
                                            cursor: 'pointer',
                                            p: 0,
                                        }}
                                        onClick={() => handleCardClick(item.type, item.id)}
                                    >
                                        {/* دائرة رقم الإحصائية */}
                                        <Box sx={{
                                            width: 68,
                                            height: 68,
                                            borderRadius: '50%',
                                            background: `linear-gradient(135deg, ${circleColor} 60%, #fff 100%)`,
                                            boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mt: 2,
                                            mb: 1.5,
                                        }}>
                                            <Typography variant='h4' sx={{ color: textColor, fontWeight: 800, fontSize: 30, textShadow: textColor === '#fff' ? '0 1px 4px #0B3C5D55' : 'none' }}>
                                                <AnimatedNumbers
                                                    animateToNumber={item.count}
                                                    fontStyle={{ fontSize: 30 }}
                                                    configs={(number, index) => {
                                                        return { mass: 1, tension: 230 * (index + 1), friction: 50 };
                                                    }}
                                                />
                                            </Typography>
                                        </Box>
                                        {/* اسم الإحصائية */}
                                        <Typography sx={{ color: '#0B3C5D', fontWeight: 700, fontSize: 16, textAlign: 'center', px: 1, mb: 1 }}>{item.name}</Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                }
            </Paper>


            <Paper
                ref={dataGridPaperRef}
                sx={{
                    p: { xs: 1, md: 3 },
                    minHeight: 200,
                    flexGrow: 1,
                    mt: 3,
                    background: '#fff',
                    borderRadius: 4,
                    boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                    border: '1px solid #e9ecef',
                }}
            >
                {/* خيارات البحث أعلى الورقة */}
                <Box sx={{ mb: 2, width: '100%' }}>
                    <DropdownMenu onFetchData={handlingFetchData} />
                </Box>
                {fetchData.loading === 'pending' ? <Progress Msg='Loading ...' /> :

                <BookingTable handlingFetchData={()=>  dispatch(getMangeData({ mode:"booking", query: searchParams.toString() }))} />
                }

            </Paper>

        </Box>

    )
}

export default Booking